<template>
  <div class="baseline-list">
    <div v-for="baseline in baselines">
      <a :title="baseline.name" @click="pushTheState(baseline)" v-bind:class="{ active: isCurrentBaseline(baseline) }">{{baseline.name}}</a>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      baselines: Array
    },
    computed: {
      currentBaseline () {
        return this.$store.state.currentBaseline
      },
      currentProject () {
        return this.$store.state.currentProject
      }
    },
    methods: {
      isCurrentBaseline (baseline) {
        if (this.currentBaseline) {
          return baseline.baseline_id === this.currentBaseline.baseline_id
        }
      },
      pushTheState (baseline) {
        window.AP.history.pushState(`${this.currentProject.id}-baselines-${baseline.baseline_id}`)
      }
    }
  }
</script>

<style>
  .baseline-list {
    font-size: 14px;
    overflow-y: auto;
    height: 70vh;
  }
  .baseline-list a {
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
  }
  .baseline-list a:hover {
    text-decoration: underline !important;
  }
</style>



// WEBPACK FOOTER //
// BaselineList.vue?3885a9ac